import { UnitType } from '@exodus/currency'

const name = 'iconmainnet'
const displayName = 'ICON'
const ticker = 'ICX'
const displayTicker = 'ICX'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#1FC5C9'
const gradientColors = ['#1FC5C9', '#137578']
const gradientCoords = { x1: '0%', y1: '0%', x2: '102%', y2: '101%' }
const chainBadgeColors = gradientColors

const units = {
  Loop: 0,
  ICX: 18,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://tracker.icon.foundation/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://tracker.icon.foundation/transaction/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Icon is a massive platform that will allow various blockchains to interact with each other via smart contracts.',
  reddit: 'https://www.reddit.com/r/helloicon/',
  twitter: 'https://twitter.com/helloiconworld',
  website: 'https://icon.foundation/',
  telegram: 'https://t.me/hello_iconworld',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
